import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ThemeProvider } from '@toolbox/style';
import {
  AgentProvider,
  FlagsProvider,
  LeadDataProvider,
  MarketDataProvider,
  TrustIconProvider,
  MarketTrendsProvider,
  CloseWidgetProvider,
  ZipCodeLocationDataProvider,
} from '@widget/core';
import { UspTextProvider } from '@widget/core/UspTextProvider';
import { TimeslotsProvider } from '@widget/core/TimeSlotsProvider';

import type { Flags, TrustIcon } from '@widget/core';
import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';
import type { USPItemProps } from '@widget/components';

export type WidgetProvidersProps = {
  market: string;
  flags: Flags;
  trustIcons?: TrustIcon[];
  uspTextItems?: USPItemProps[] | undefined | null;
  localizedUspLabel?: string | undefined | null;
  widgetXBaseApi?: string;
};

export const WidgetProviders: ReactFCWithChildren<WidgetProvidersProps> = ({
  children,
  market,
  flags,
  trustIcons,
  uspTextItems,
  localizedUspLabel,
}) => {
  const queryClient = new QueryClient();
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <TrustIconProvider trustIcons={trustIcons}>
          <UspTextProvider uspTextItems={uspTextItems} localizedUspLabel={localizedUspLabel}>
            <FlagsProvider flags={flags}>
              <LeadDataProvider>
                <AgentProvider>
                  <CloseWidgetProvider>
                    <MarketTrendsProvider>
                      <MarketDataProvider market={market}>
                        <ZipCodeLocationDataProvider>
                          <TimeslotsProvider>{children}</TimeslotsProvider>
                        </ZipCodeLocationDataProvider>
                      </MarketDataProvider>
                    </MarketTrendsProvider>
                  </CloseWidgetProvider>
                </AgentProvider>
              </LeadDataProvider>
            </FlagsProvider>
          </UspTextProvider>
        </TrustIconProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
};
